
import { useState } from "react";

const TripAdvisorButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    // Open TripAdvisor in a new tab safely
    try {
      window.open("https://www.tripadvisor.com", "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Failed to open TripAdvisor:", error);
    }
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-6 left-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer"
      style={{ backgroundColor: "#34E0A1" }}
      aria-label="Ver reseñas en TripAdvisor"
    >
      <div className="relative w-8 h-8 flex items-center justify-center">
        <svg viewBox="0 0 24 24" fill="white" className="w-7 h-7">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm-5.5 4.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5S5 11.83 5 11s.67-1.5 1.5-1.5zm11 0c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM12 18c-2.33 0-4.32-1.45-5.12-3.5h1.67c.69 1.19 1.97 2 3.45 2s2.76-.81 3.45-2h1.67c-.8 2.05-2.79 3.5-5.12 3.5z"/>
        </svg>
      </div>

      {/* Tooltip */}
      <span
        className={`
          absolute left-16 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap
          transition-all duration-300
          ${isHovered ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-2 pointer-events-none"}
        `}
      >
        Ver reseñas en TripAdvisor
      </span>
    </button>
  );
};

export default TripAdvisorButton;
